import { EXeroPaymentMethod } from "@/utilities/enums/Payment";
import { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { Button } from "rizzui";

interface ICreditCardInstructionsProps {
  paymentLink: string;
  onClose: () => void;
  onBack: (initMethod?: EXeroPaymentMethod) => void;
  handleClickPaymentComplete: () => void;
}

export default function CreditCardInstructions(
  props: ICreditCardInstructionsProps
) {
  const { paymentLink, onClose, onBack, handleClickPaymentComplete } = props;
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const handleClickPaymentLink = () => {
    setIsClicked(true);
    window.open(paymentLink, "_blank");
  };

  return (
    <div className="w-full p-6 bg-white shadow-md rounded-lg text-gray-700">
      <h3 className="text-xl font-semibold mb-4">
        Credit Card Payment Instructions
      </h3>
      <ol className="list-decimal list-inside space-y-3">
        <li>
          Click{" "}
          <span className="font-semibold inline-block p-0">
            “Generate Payment Link”
          </span>{" "}
          to open the payment page.
        </li>
        <li>Complete the payment on the page that opens.</li>
        <li>
          Once the payment is successful, click{" "}
          <span className="font-semibold background-transparent inline-block p-0">
            “I’ve Completed the Payment”
          </span>{" "}
          to return to the dashboard.
        </li>
      </ol>
      <div className="w-full mt-4 flex flex-row justify-around">
        <Button
          variant="outline"
          onClick={() => onBack(EXeroPaymentMethod.PAY_NOW)}
        >
          <IoIosArrowRoundBack />
          Back
        </Button>
        <Button onClick={handleClickPaymentLink}>
          <IoIosArrowRoundBack />
          Generate Payment Link
        </Button>
        <Button
          disabled={!isClicked}
          onClick={handleClickPaymentComplete}
          className="enabled:bg-green-600"
        >
          <IoIosArrowRoundBack />
          I’ve Completed the Payment
        </Button>
      </div>
    </div>
  );
}
